var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAnnouncementInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03125 19.5V4.5C4.03125 3.83696 4.29674 3.20107 4.76931 2.73223C5.24188 2.26339 5.88283 2 6.55114 2H19.1506C19.4179 2 19.6743 2.10536 19.8633 2.29289C20.0524 2.48043 20.1586 2.73478 20.1586 3V21C20.1586 21.2652 20.0524 21.5196 19.8633 21.7071C19.6743 21.8946 19.4179 22 19.1506 22H6.55114C5.88283 22 5.24188 21.7366 4.76931 21.2678C4.29674 20.7989 4.03125 20.163 4.03125 19.5ZM4.03125 19.5C4.03125 18.837 4.29674 18.2011 4.76931 17.7322C5.24188 17.2634 5.88283 17 6.55114 17H20.1586",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06445 13L12.0963 6L16.1281 13",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17188 11H14.9172",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnnouncementInactive);
export default __webpack_public_path__ + "static/media/ic-announcement-inactive.759b0ab1c99594bea91da4a56bb6dec8.svg";
export { ForwardRef as ReactComponent };